var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLetter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.832 2.5H8.16536C4.7084 2.5 2.97991 2.5 1.90597 3.59835C0.832031 4.6967 0.832031 6.46447 0.832031 10C0.832031 13.5355 0.832031 15.3033 1.90597 16.4017C2.97991 17.5 4.7084 17.5 8.16536 17.5H11.832C15.289 17.5 17.0175 17.5 18.0914 16.4017C19.1654 15.3033 19.1654 13.5355 19.1654 10C19.1654 6.46447 19.1654 4.6967 18.0914 3.59835C17.0175 2.5 15.289 2.5 11.832 2.5Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9401 6.69516C16.2318 6.45209 16.2712 6.01857 16.0282 5.72688C15.7851 5.43519 15.3516 5.39578 15.0599 5.63886L13.0809 7.28801C12.2257 8.00069 11.6319 8.49389 11.1307 8.81629C10.6454 9.12838 10.3163 9.23314 10 9.23314C9.6837 9.23314 9.35463 9.12838 8.86939 8.81629C8.3681 8.49389 7.77435 8.00069 6.91913 7.28801L4.94014 5.63886C4.64845 5.39578 4.21494 5.43519 3.97187 5.72688C3.72879 6.01857 3.7682 6.45209 4.05989 6.69516L6.07334 8.37304C6.88584 9.05014 7.54437 9.59894 8.1256 9.97275C8.73105 10.3622 9.3207 10.6081 10 10.6081C10.6793 10.6081 11.269 10.3622 11.8744 9.97275C12.4557 9.59894 13.1142 9.05013 13.9267 8.37303L15.9401 6.69516Z",
    fill: "#818181"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLetter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Letter.0c27550d9f658a1188844b277496b6f8.svg";